import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MachineDetali from './components/MachineDetali';
import TabsProvider from './components/TabsProvider';
import { useTranslation } from 'react-i18next';

const DetailView = ({ machineDetail }) => {
  const [expandedDetalis, setExpandedDetalis] = useState(true);
  const { t, i18n } = useTranslation();

  const handleChangeSastavnice = () => {
    setExpandedDetalis(!expandedDetalis);
  };
  return (
    <div>
      <Accordion expanded={expandedDetalis} onChange={handleChangeSastavnice}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <strong>title</strong>
        </AccordionSummary>
        <AccordionDetails>
          <MachineDetali machine={machineDetail} />
        </AccordionDetails>
      </Accordion>
      <TabsProvider machine={machineDetail} />
    </div>
  );
};

export default DetailView;
